<template>
  <div
    v-if="showModal"
    class="modal auth-ui-modal"
  >
    <div
      class="modal-background"
      @click="toggleModal"
    />
    <div
      :class="classes"
      class="modal-card"
    >
      <header class="modal-card-head">
        <p
          v-if="hasSlot('header-title')"
          class="modal-card-title auth-ui-modal-card-title"
        >
          <slot name="header-title" />
        </p>
        <button
          class="delete"
          aria-label="close"
          @click.prevent="toggleModal()"
        />
      </header>
      <section
        v-if="hasSlot('body')"
        class="modal-card-body"
      >
        <slot name="body" />
      </section>
      <footer class="modal-card-foot" />
    </div>
  </div>
</template>

<script>
/* ============
   * Modal Component
   * ============
   *
   * A basic modal component.
   * To toggle from a parent:
   * - Add to template: <v-modal ref="reportModal">
   * - Call this component's toggle method from parent: this.$refs.reportModal.toggleModal();
   *
   */

import SlotMixin from '@/mixins/slot';

export default {
  name: 'Modal',

  mixins: [
    SlotMixin,
  ],

  props: {
    classes: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  methods: {
    toggleModal() {
      if (this.showModal) {
        document.documentElement.classList.remove('is-clipped');
      } else {
        document.documentElement.classList.add('is-clipped');
      }
      this.showModal = !this.showModal;
    },
  },
};
</script>
